import { render } from "./Login.vue?vue&type=template&id=acbb8dba&bindings={\"toggle\":\"setup\",\"onSubmit\":\"setup\",\"verifyRef\":\"setup\"}"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script